import moment from "moment";

export default function PackagesTable({ data }) {
    return (
        <div className="col-md-12 col-lg-12 col-xl-12">
            <div className="card">
                <div className="card-datatable  pt-0">
                    <div className='dataTables_wrapper dt-bootstrap5 no-footer'>
                        <div className='row dt-row'>
                            <div className='col-sm-12' style={{ maxHeight: "350px", overflowY: "auto" }}>
                                <table className="table hidelastrowborder">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Kind</th>
                                            <th>Invitations</th>
                                            <th>Demos</th>
                                            <th>Images</th>
                                            <th>Videos</th>
                                            <th>Started On</th>
                                            <th>Ended On</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data && data.length > 0 &&
                                            data.map((pkg, index) => {
                                                return (<tr key={index}>
                                                    <td>{pkg.packageName}</td>
                                                    <td>{pkg.packageKind}</td>
                                                    <td>{pkg.eventCount}</td>
                                                    <td>{pkg.allowableDemoCount}</td>
                                                    <td>{pkg.allowableImageCount}</td>
                                                    <td>{pkg.allowableVideoCount}</td>
                                                    <td>{moment(pkg.startDate).format("DD-MM-yyyy")}</td>
                                                    <td>{moment(pkg.endDate).format("DD-MM-yyyy")}</td>
                                                    <td>
                                                        <div className={(pkg.isExpired ? "text-danger" : "text-success")}>
                                                            {pkg.isExpired ? "Expired" : "Active"}
                                                        </div>
                                                    </td>
                                                </tr>)
                                            })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}